import React from 'react';
import ProjectFilter from '@common/ProjectFilter';
function ProjectPage() {

    return (
        <div className={'HomePageSection'}>
            <ProjectFilter />
            
        </div>
    )
}

export default ProjectPage;
